/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';
import { resBreak } from '@/utils/resBreak';

export const headerNavBarItemSX: SxProps = {
	display:resBreak<'display'>({mobile:'none', desktop:'block', tablet:'block'}),
	cursor:'pointer',
	'&.MuiButton-text': {
		p: 2,
		backgroundColor: 'transparent',
		color: '#000000',
		'&:hover': {
			textDecoration:'underline',
		},
		fontSize: 16,
		fontWeight:400,
		borderRadius: 0,
		'&:is(a):not([href])': {
			cursor: 'pointer',
		},
	},
};
